import { render, staticRenderFns } from "./WpActivityLog.vue?vue&type=template&id=dee40bcc&"
import script from "./WpActivityLog.vue?vue&type=script&lang=js&"
export * from "./WpActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports